/*
* OfferChildsReducer
*/

import { fromJS, List } from 'immutable';
import {
  SET_CHILD_OFFERS,
  ADD_CHILD_OFFER,
  REPLACE_CHILD_OFFER,
  REMOVE_CHILD_OFFER,
  EDIT_CHILD_OFFER,
  EDIT_CHILD_OFFER_END,
  VALIDATE_USER_INPUT,
  SET_ERROR_MESSAGE,
  RESET,
  RESET_ERRORS,
  SET_LOADING,
} from './constants';

// The initial state of the App
export const initialState = fromJS({
  loading: false,
  offers: [],
  hasError: false,
  errorMsg: '',
  editMode: false,
});

function childOffersReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LOADING:
      return state.set('loading', action.loading);
    case SET_CHILD_OFFERS:
      return state.set('offers', action.offers);
    case EDIT_CHILD_OFFER:
      return state.set('editMode', action.id)
        .set('hasError', false)
        .set('errorMsg', '')
        .set('loading', false);
    case EDIT_CHILD_OFFER_END:
      return state.set('editMode', false)
        .set('hasError', false)
        .set('errorMsg', '')
        .set('loading', action.loading);
    case ADD_CHILD_OFFER:
      return state.update('offers', offers => {
        let offersList = new List(offers)
        return offersList.push({...action.offer, isChild: true}).toJS()
      }).set('loading', action.loading);
    case REPLACE_CHILD_OFFER:
      return state.update('offers', offers => {
        let offerIdx = offers.findIndex(offer => offer.ref === action.offer.ref);
        offers.splice(offerIdx, 1, action.offer);
        return offers;
      }).set('loading', action.loading);
    case REMOVE_CHILD_OFFER:
      return state.update('offers', offers => offers.filter(offer => offer.ref !== action.id)).set('loading', false);
    case VALIDATE_USER_INPUT:
      return state.set('hasError', action.hasError);
    case SET_ERROR_MESSAGE:
      return state.set('errorMsg', action.msg).set('hasError', true).set('loading', false);
    case RESET:
      return initialState;
    case RESET_ERRORS:
      return state.set('errorMsg', '').set('hasError', false);
    default:
      return state;
  }
}

export default childOffersReducer;
